import { PizarraLastEventosRequested, PizarraActionTypes, PizarraLastEventosLoaded, PizarraCancelled, PizarraRight } from './pizarra.actions';
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { PizarraService } from '../../services/pizarra.service';
import { Observable, of } from 'rxjs';
import { switchMap, map, catchError, withLatestFrom } from 'rxjs/operators';
import { AppState } from 'src/app/reducers';
import { Action, Store } from '@ngrx/store';
import { pizarraMaxEventQty, pizarraStatus } from './pizarra.selectors';
import { ContenidoStatus } from 'src/common/contenido';
import { ToastService } from 'src/app/services/toast.service';


@Injectable()
export class PizarraEffects {

	loadLastEventos$ = createEffect( () => {
		return this.actions$.pipe(
			ofType<PizarraLastEventosRequested>( PizarraActionTypes.PizarraLastEventosRequested ),
			withLatestFrom( this.store.select( pizarraMaxEventQty ) ),
			switchMap( ( [ action, maxEventQty ] ) => {
				return this.service.findPizarraStatus( maxEventQty ).pipe(
					map( remoteStatus => {
						return { action, remoteStatus };
					} ),
					catchError( error => of( { action, remoteStatus: null } ) )
				);
			} ),
			withLatestFrom( this.store.select( pizarraStatus ), this.store.select( pizarraMaxEventQty ) ),
			switchMap( ( [ data, localStatus, maxEventQty ] ) => {
				let resultAction: Observable<Action>;
				let cleared = false;
				let shouldLoadContent = false;
				let remoteStatus: ContenidoStatus = data["remoteStatus"];
				
				if ( remoteStatus == null ) {
					resultAction = of( new PizarraCancelled( { status: null } ) );
					this.toastService.danger( "No se pudo obtener el estado de la pizarra" );
				} else {
					// Hay actualizaciones nuevas?
					if (
						( localStatus && localStatus.lastUpdate && localStatus.qty >= 0 ) &&
					 	( localStatus.lastUpdate.getTime() != remoteStatus.lastUpdate.getTime() || localStatus.qty != remoteStatus.qty )
					) {
						cleared = true;
					};

					// Se carga el componente por primera vez?
					if( !localStatus )
						shouldLoadContent = true;

					if( remoteStatus.qty == 0 ) {
						resultAction = of( new PizarraLastEventosLoaded({ status: remoteStatus, eventos: [] }) );
					} else if( cleared || shouldLoadContent ) {
						resultAction = this.service.findLastEventos( maxEventQty )
							.pipe(
								map( eventos => {
									// Eventos debería siempre tener elementos en esta instancia =>
									// dado que remoteStatus.qty > 0
									return eventos.length == 0 ? new PizarraCancelled({ status: localStatus }) : new PizarraLastEventosLoaded( { status: remoteStatus, eventos } );
								}),
								catchError( error => {
									// Si no pude recuperar los nuevos eventos, me quedo con el status local, no actualizo al nuevo (remoteStatus)
									// El status y los eventos del store deben estar sincronizados
									this.toastService.danger( "No se pudo obtener la pizarra" );
									return of( new PizarraCancelled( { status: localStatus } ) );
								})
							);
					} else {
						// No hubieron cambios en la pizarra
						resultAction = of( new PizarraRight() );
					}
				};
				return resultAction;
			})
		)
	} );

	constructor( private actions$: Actions, private store: Store<AppState>, private service: PizarraService, private toastService: ToastService ) {};

};